module.exports = __webpack_public_path__ + "static/media/activeaccounticon.309c80a6.svg";